namespace NasVault {
  export function openDeleteDialog(item: Item): void {
    state.deleteTarget = item;
    const description = element("nasDeleteDescription");
    if (description) description.textContent = `'${item.name}'을(를) 삭제할까요? 이 작업은 되돌릴 수 없습니다.`;
    const dialog = element("nasDeleteDialog");
    if (dialog) dialog.hidden = false;
  }

  function closeDeleteDialog(): void {
    state.deleteTarget = null;
    const dialog = element("nasDeleteDialog");
    if (dialog) dialog.hidden = true;
  }

  async function confirmDelete(): Promise<void> {
    const item = state.deleteTarget;
    if (!item) return;
    const button = element<HTMLButtonElement>("nasDeleteConfirm");
    if (button) { button.disabled = true; button.textContent = "삭제 중…"; }
    try {
      await api.remove(joinPath(state.currentPath, item.name));
      closeDeleteDialog();
      setStatus(`${item.name}을(를) 삭제했어요.`);
      await load(state.currentPath);
    } catch (error) {
      setStatus(error instanceof Error ? error.message : "삭제하지 못했어요.", true);
    } finally {
      if (button) { button.disabled = false; button.textContent = "삭제"; }
    }
  }

  export function bindDeleteDialog(): void {
    element("nasDeleteCancel")?.addEventListener("click", closeDeleteDialog);
    element("nasDeleteConfirm")?.addEventListener("click", () => void confirmDelete());
  }
}
